import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-source-not-available",
  "use": "icon-source-not-available-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-source-not-available\"><path d=\"M29.605 2.444a1 1 0 0 1 0 1.414L3.707 29.708a1 1 0 1 1-1.414-1.415l1.191-1.189A4 4 0 0 1 2 24V8c0-2.2 1.8-4 4-4h20q.3 0 .588.043l1.603-1.6a1 1 0 0 1 1.414 0ZM28 10a1 1 0 0 1 1 1v14.098a3 3 0 0 1-3 3h-.018L10.994 28a1 1 0 0 1 .012-2l14.988.098c.558 0 1.006-.447 1.006-1V11a1 1 0 0 1 1-1M9 12H4v12c0 .77.329 1.375.882 1.71L9 21.597zm9.616 0H11v7.601zm6.011-6H6c-1.2 0-2 .8-2 2v2h16.619z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol